import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { ProtectedLayout } from "./components/ProtectedLayout";
import { CookieBanner } from "./components/CookieBanner";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import Feed from "./pages/Feed";
import Profile from "./pages/Profile";
import Explore from "./pages/Explore";
import Messages from "./pages/Messages";
import Podcast from "./pages/Podcast";
import HelpBoard from "./pages/HelpBoard";
import Settings from "./pages/Settings";
import Notifications from "./pages/Notifications";
import { PrivacyPolicy, CookiePolicy, Terms } from "./pages/Legal";
import Unsubscribe from "./pages/Unsubscribe";

const PublicOnly = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (user) {
        if (!user.onboarded) return <Navigate to="/onboarding" replace />;
        return <Navigate to="/feed" replace />;
    }
    return children;
};

function App() {
    return (
        <div className="App font-body">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <CookieBanner />
                    <Routes>
                        <Route path="/" element={<PublicOnly><Landing /></PublicOnly>} />
                        <Route path="/login" element={<PublicOnly><Auth mode="login" /></PublicOnly>} />
                        <Route path="/register" element={<PublicOnly><Auth mode="register" /></PublicOnly>} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/cookie-policy" element={<CookiePolicy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/unsubscribe" element={<Unsubscribe />} />
                        <Route path="/onboarding" element={<Onboarding />} />
                        <Route path="/feed" element={<ProtectedLayout><Feed /></ProtectedLayout>} />
                        <Route path="/profile/:user_id" element={<ProtectedLayout><Profile /></ProtectedLayout>} />
                        <Route path="/explore" element={<ProtectedLayout><Explore /></ProtectedLayout>} />
                        <Route path="/messages" element={<ProtectedLayout><Messages /></ProtectedLayout>} />
                        <Route path="/podcast" element={<ProtectedLayout><Podcast /></ProtectedLayout>} />
                        <Route path="/help" element={<ProtectedLayout><HelpBoard /></ProtectedLayout>} />
                        <Route path="/notifications" element={<ProtectedLayout><Notifications /></ProtectedLayout>} />
                        <Route path="/settings" element={<ProtectedLayout><Settings /></ProtectedLayout>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
